import { Inject, Injectable } from '@angular/core';

import { TwcPosition } from '@topcon/twc-angular/lib/common/utils/relative-positioning/relative-positioning.types';

import {
    ActionToolbarString,
    ITEMS_TOOLBAR_CONFIGURATION_TOKEN,
    ItemToolbarConfiguration,
    OptionToolbar,
    WidgetType,
} from '@mirage-projects/cw-commons';

@Injectable({ providedIn: 'root' })
export class ToolbarHelperService {
    constructor(@Inject(ITEMS_TOOLBAR_CONFIGURATION_TOKEN) private toolsConfiguration: ItemToolbarConfiguration[]) {}

    getDefaultOption(idOption: ActionToolbarString, idWidget: WidgetType, placementTooltip: TwcPosition = 'right'): OptionToolbar | null {
        const toolConfig = this.toolsConfiguration.find((tool) => tool.id === idOption);
        if (!toolConfig) {
            return null;
        }
        const option: OptionToolbar = {
            data: { id: idOption, widget: idWidget },
            icon: toolConfig.icon,
            tooltip: toolConfig.tooltip,
            placementTooltip,
        };
        return option;
    }
}
